import PreviewDetailImg from 'assets/images/feature-slots/preview_detail.png';
import PreviewDListlImg from 'assets/images/feature-slots/preview_list.png';
import { SLOT_KEY, getRouteName } from './common';

const MODULE_NAME = 'PPM';

const routes = [
    {
        matchRegex: '/PPMContract/Create',
        name: getRouteName(MODULE_NAME, 'Add PPM'),
        slots: [
            SLOT_KEY.SLOT_V_SECTION,
            SLOT_KEY.SLOT_SCRIPTS,
        ],
        image: PreviewDListlImg,
        parentKeys: {
            [SLOT_KEY.SLOT_V_SECTION]: [
                { key: 'page-title-action', label: 'Section Page Title Action' },
                { key: 'page-title-main', label: 'Section Page Title' },
                { key: 'form-section-bar-end', label: 'Form Action Bar End' },
            ],
        },
        options: {
            [SLOT_KEY.SLOT_SCRIPTS]: [
                { key: 'MARKETPLACE_EVENT_BEFORE_SUBMIT_FORM', label: 'Before Submit Form' },
                { key: 'MARKETPLACE_EVENT_AFTER_SUBMIT_FORM_SUCCESS', label: 'After Submit Form Successfully' },
                { key: 'MARKETPLACE_EVENT_BEFORE_SUBMIT_FORM_CONTRACT', label: 'Before Submit Form for PPM Contract' },
                { key: 'MARKETPLACE_EVENT_AFTER_SUBMIT_FORM_CONTRACT_SUCCESS', label: 'After Submit Form for PPM Contract Successfully' },
            ],
        },
    },
    {
        matchRegex: '/PPMContract/CreateAssetPPM',
        name: getRouteName(MODULE_NAME, 'Add Asset PPM'),
        slots: [
            SLOT_KEY.SLOT_V_SECTION,
            SLOT_KEY.SLOT_SCRIPTS,
        ],
        image: PreviewDListlImg,
        parentKeys: {
            [SLOT_KEY.SLOT_V_SECTION]: [
                { key: 'page-title-action', label: 'Section Page Title Action' },
                { key: 'page-title-main', label: 'Section Page Title' },
                { key: 'form-section-bar-end', label: 'Form Action Bar End' },
            ],
        },
        options: {
            [SLOT_KEY.SLOT_SCRIPTS]: [
                { key: 'MARKETPLACE_EVENT_BEFORE_SUBMIT_FORM', label: 'Before Submit Form' },
                { key: 'MARKETPLACE_EVENT_AFTER_SUBMIT_FORM_SUCCESS', label: 'After Submit Form Successfully' },
                { key: 'MARKETPLACE_EVENT_BEFORE_SUBMIT_FORM_CONTRACT', label: 'Before Submit Form for PPM Contract' },
                { key: 'MARKETPLACE_EVENT_AFTER_SUBMIT_FORM_CONTRACT_SUCCESS', label: 'After Submit Form for PPM Contract Successfully' },
            ],
        },
    },
    {
        matchRegex: '/PPMContract',
        name: getRouteName(MODULE_NAME, 'All PPM Contracts'),
        slots: [
            SLOT_KEY.SLOT_SECTION,
            SLOT_KEY.SLOT_SCRIPTS,
            SLOT_KEY.SLOT_V_TABLE_COLUMN
        ],
        image: PreviewDListlImg,
        parentKeys: {
            [SLOT_KEY.SLOT_SECTION]: [
                { key: 'page-title-main', label: 'Section Page Title' },
                { key: 'page-title-action', label: 'Section Page Title Action' },
            ],
            [SLOT_KEY.SLOT_V_TABLE_COLUMN]: [
                { key: 'ppm-contract-table', label: 'PPM Contract Table' },
            ],
        },
        options: {
            [SLOT_KEY.SLOT_SCRIPTS]: [
                { key: 'MARKETPLACE_EVENT_TAB_CHANGE', label: 'Before Tab Change' },
                {
                    key: 'MARKETPLACE_EVENT_TOGGLE_BATCHING',
                    label: 'Before Toogle Batching',
                },
                {
                    key: 'MARKETPLACE_EVENT_TOGGLE_TABLE_SETTING',
                    label: 'Before Toogle Table Setting',
                },
            ],
        }
    },
    {
        matchRegex: '/PPMQuote',
        name: getRouteName(MODULE_NAME, 'All PPM Quotes'),
        slots: [
            SLOT_KEY.SLOT_SECTION,
            SLOT_KEY.SLOT_SCRIPTS,
            SLOT_KEY.SLOT_V_TABLE_COLUMN
        ],
        image: PreviewDListlImg,
        parentKeys: {
            [SLOT_KEY.SLOT_SECTION]: [
                { key: 'page-title-main', label: 'Section Page Title' },
                { key: 'page-title-action', label: 'Section Page Title Action' },
            ],
            [SLOT_KEY.SLOT_V_TABLE_COLUMN]: [
                { key: 'ppm-quote-table', label: 'PPM Quote Table' },
            ],
        },
        options: {
            [SLOT_KEY.SLOT_SCRIPTS]: [
                { key: 'MARKETPLACE_EVENT_TAB_CHANGE', label: 'Before Tab Change' },
                {
                    key: 'MARKETPLACE_EVENT_TOGGLE_BATCHING',
                    label: 'Before Toogle Batching',
                },
                {
                    key: 'MARKETPLACE_EVENT_TOGGLE_TABLE_SETTING',
                    label: 'Before Toogle Table Setting',
                },
            ],
        }
    },
    {
        matchRegex: '/PPMContract/BatchDeploy',
        name: getRouteName(MODULE_NAME, 'Batch Deploy Subcontractor PPM Visits'),
        slots: [
            SLOT_KEY.SLOT_V_SECTION,
        ],
        image: PreviewDListlImg,
        parentKeys: {
            [SLOT_KEY.SLOT_V_SECTION]: [
                { key: 'page-title-main', label: 'Section Page Title' },
                { key: 'section-table-action', label: 'Section Table Action' },
                { key: 'modal-additional-section', label: 'Section Modal Batch Deploy' }
            ],
        },
    },
    {
        matchRegex: '/PPMPartRequired',
        name: getRouteName(MODULE_NAME, 'PPM Parts Required'),
        slots: [
            SLOT_KEY.SLOT_V_SECTION,
        ],
        image: PreviewDListlImg,
        parentKeys: {
            [SLOT_KEY.SLOT_V_SECTION]: [
                { key: 'page-title-main', label: 'Section Page Title' },
                { key: 'page-title-action', label: 'Section Page Action' },
            ],
        },
    },
    {
        matchRegex: '/PPMQuote/Detail/:id',
        name: getRouteName(MODULE_NAME, 'PPM Quotes Detail'),
        slots: [
            SLOT_KEY.SLOT_TAB,
            SLOT_KEY.SLOT_CONTENT,
            SLOT_KEY.SLOT_V_SECTION,
            SLOT_KEY.SLOT_V_FORM_SECTION
        ],
        image: PreviewDListlImg,
        parentKeys: {
            [SLOT_KEY.SLOT_V_SECTION]: [
                { key: 'page-title-main', label: 'Section Page Title' },
                { key: 'page-title-action', label: 'Section Page Action' },
                { key: 'tab-details-wrapper-form', label: 'Tab Details - Wrapper form' },
                { key: 'tab-details-detail-title-action', label: 'Tab Details - Detail Title Action' },
                { key: 'wrapper-section-audit', label: 'Tab History Audit - Wrapper section' },
            ],
            [SLOT_KEY.SLOT_V_FORM_SECTION]: [
                { key: 'notes-tab', label: 'Tab Notes - Wrapper form' },
            ],
        },
    },
    {
        matchRegex: '/PPMContract/Detail/:id',
        name: getRouteName(MODULE_NAME, 'PPM Contract Detail'),
        slots: [
            SLOT_KEY.SLOT_TAB,
            SLOT_KEY.SLOT_CONTENT,
            SLOT_KEY.SLOT_V_SECTION,
            SLOT_KEY.SLOT_SECTION,
            SLOT_KEY.SLOT_V_FORM_SECTION,
            SLOT_KEY.SLOT_V_TABLE_COLUMN,
            SLOT_KEY.SLOT_SCRIPTS,
        ],
        image: PreviewDListlImg,
        options: {
            [SLOT_KEY.SLOT_SCRIPTS]: [
                { key: 'MARKETPLACE_EVENT_GET_APP_ID_AI_SUGGESTION', label: 'Get AppId AI Suggestion' },
            ],
        },
        parentKeys: {
            [SLOT_KEY.SLOT_SECTION]: [
                { key: 'page-title-main', label: 'Section Page Title' },
                { key: 'page-title-action', label: 'Section Page Action' },
                { key: 'tab-details-detail-title-action', label: 'Tab Details - Detail Title Action' },
                { key: 'tab-visit-section-search-list', label: 'Tab Visit - Section Search List' },
                { key: 'wrapper-form-invoice-header', label: 'Tab Invoice Header - Wrapper Form' },
                { key: 'wrapper-summary-form', label: 'Tab Schedule - Wrapper Summary' },
                { key: 'detail-title-action', label: 'Tab Schedule - Detail Title Action' },
            ],
            [SLOT_KEY.SLOT_V_SECTION]: [
                { key: 'wrapper-invoice-list', label: 'Tab Invoices - Wrapper Section List' },
                { key: 'wrapper-section-audit', label: 'Tab History Audit - Wrapper section' },
                { key: 'wrapper-contract-list', label: 'Tab Contract Purchase Order - Wrapper section' },
                { key: 'wrapper-visits-engineer', label: 'Tab Visits - Engineer section' },
            ],
            [SLOT_KEY.SLOT_V_FORM_SECTION]: [
                { key: 'notes-tab', label: 'Tab Note - Wrapper Section Form' },
            ],
            [SLOT_KEY.SLOT_V_TABLE_COLUMN]: [
                { key: 'invoice-list', label: 'Invoice List' },
            ],
        },
    },
    {
        matchRegex: '/PPMCredit/Detail/:id',
        name: getRouteName(MODULE_NAME, 'PPM Credit Detail'),
        slots: [
            SLOT_KEY.SLOT_V_TABLE_COLUMN,
            SLOT_KEY.SLOT_SCRIPTS,
        ],
        image: PreviewDListlImg,
        parentKeys: {
            [SLOT_KEY.SLOT_V_TABLE_COLUMN]: [
                { key: 'credit-line-list', label: 'Credit line List' },
            ],
        },
        options: {
            [SLOT_KEY.SLOT_SCRIPTS]: [
                { key: 'MARKETPLACE_EVENT_GET_COLUMN', label: 'Show data column in line credit' },
            ],
        },
    }
]

export default routes;